import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Home, Swords, Compass, User, Plus, Bell } from 'lucide-react';
import { useI18n } from '../context/I18nContext';
import { useNotifications } from '../context/NotificationsContext';
import CreateSheet from './CreateSheet';

export default function BottomNav() {
  const { t } = useI18n();
  const { unread } = useNotifications();
  const navigate = useNavigate();
  const [creating, setCreating] = useState(false);

  const NAV = [
    { to: '/home', icon: Home, key: 'nav.home', tid: 'nav-home' },
    { to: '/battles', icon: Swords, key: 'nav.battles', tid: 'nav-battles' },
    { center: true, icon: Plus, key: 'nav.create', tid: 'nav-create' },
    { to: '/discover', icon: Compass, key: 'nav.discover', tid: 'nav-discover' },
    { to: '/me', icon: User, key: 'nav.profile', tid: 'nav-profile' },
  ];

  return (
    <>
      <nav
        data-testid="bottom-nav"
        className="fixed bottom-0 inset-x-0 z-40 border-t border-white/10 bg-aura-surface/80 backdrop-blur-2xl pb-[env(safe-area-inset-bottom)]"
      >
        <div className="mx-auto max-w-md flex items-center justify-around px-2 py-2">
          {NAV.map(({ to, icon: Icon, key, tid, center }) => {
            if (center) {
              return (
                <button key="create" onClick={() => setCreating(true)} data-testid={tid} className="relative -mt-6 flex flex-col items-center">
                  <span className="grid place-items-center h-14 w-14 rounded-full bg-aura-gradient text-black shadow-neon-cyan">
                    <Icon size={26} strokeWidth={2.5} />
                  </span>
                </button>
              );
            }
            return (
              <NavLink
                key={to} to={to} data-testid={tid}
                className={({ isActive }) => `group flex flex-col items-center justify-center gap-1 py-1 w-14 transition ${isActive ? 'text-aura-cyan' : 'text-aura-textDim hover:text-white'}`}
              >
                {({ isActive }) => (
                  <>
                    <Icon size={22} strokeWidth={isActive ? 2.4 : 1.8} className={isActive ? 'drop-shadow-[0_0_10px_rgba(0,240,255,0.7)]' : ''} />
                    <span className="text-[10px] font-display font-medium tracking-wide">{t(key)}</span>
                  </>
                )}
              </NavLink>
            );
          })}
        </div>
      </nav>
      <button
        onClick={() => navigate('/notifications')}
        data-testid="notifications-fab"
        className="fixed top-4 right-4 z-30 grid place-items-center h-10 w-10 rounded-full bg-aura-surface/70 backdrop-blur border border-white/10 hover:border-aura-cyan/50 md:top-6 md:right-6"
      >
        <Bell size={18} className="text-white" />
        {unread > 0 && <span className="absolute -top-1 -right-1 h-4 min-w-[16px] px-1 grid place-items-center rounded-full bg-aura-pink text-[9px] font-bold text-white">{unread > 99 ? '99+' : unread}</span>}
      </button>
      <CreateSheet open={creating} onClose={() => setCreating(false)} />
    </>
  );
}
